import DoAPICall from './DoAPICall'

//Create menu
    export async function createMenu(userToken, menu){
            const apiPayload = {
                httpMethod:'post',
                userToken,
                uri:'clientmenus',
                payLoad:{
                    client_id:menu.client_id,
                    parent_id:menu.parent_id,
                    order:menu.order,
                    prompt:menu.prompt,
                    handler:menu.handler,
                    billingClient:menu.billingClient,
                    description:menu.description,
                    shortcutHandler:menu.shortcutHandler,
                    shortcut:menu.shortcut,
                    isPayment:menu.isPayment,
                    receiptingHandler:menu.receiptingHandler,
                    isDefault:menu.isDefault,
                    isActive:menu.isActive,
                    cAccountCode:menu.cAccountCode,
                    onOneAccount:menu.onOneAccount,
                    commonAccount:menu.commonAccount,
                    customerAccountPrompt:menu.customerAccountPrompt,
                    amountPrompt:menu.amountPrompt,
                    amountFixed:menu.amountFixed,
                    requiredAmount:menu.requiredAmount,
                    requiresReference:menu.requiresReference,
                    referencePrompt:menu.referencePrompt,
                },
                requestOptions:{}
            }
            return await DoAPICall(apiPayload)
        }

//Get All menu
    export async function getMenus(userToken){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientmenus',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Get Menus of Client
    export async function getMenusofClient(userToken,client_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'menusofclient/'+client_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function getLevelOneMenusofClient(userToken,client_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'levelonemenusofclient/'+client_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)

    }

    export async function getSubMenusofClient(userToken,parent_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'submenusofclient/'+parent_id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)

    }

//Get One menu
    export async function getMenu(userToken, id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'clientmenus/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

    export async function getRootMenu(userToken, client_id){
        const apiPayload = {
            httpMethod:'get',
            userToken,
            uri:'rootmenu?client_id='+client_id+'&parentMenu=0',
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Update menu
    export async function updateMenu(userToken, menu){
        const apiPayload = {
            httpMethod:'put',
            userToken,
            uri:'clientmenus/'+menu.id,
            payLoad:{
                parent_id:menu.parent_id,
                order:menu.order,
                prompt:menu.prompt,
                handler:menu.handler,
                billingClient:menu.billingClient,
                description:menu.description,
                shortcutHandler:menu.shortcutHandler,
                shortcut:menu.shortcut,
                isPayment:menu.isPayment,
                receiptingHandler:menu.receiptingHandler,
                isDefault:menu.isDefault,
                isActive:menu.isActive,
                cAccountCode:menu.cAccountCode,
                onOneAccount:menu.onOneAccount,
                commonAccount:menu.commonAccount,
                customerAccountPrompt:menu.customerAccountPrompt,
                amountPrompt:menu.amountPrompt,
                amountFixed:menu.amountFixed,
                requiredAmount:menu.requiredAmount,
                requiresReference:menu.requiresReference,
                referencePrompt:menu.referencePrompt
            },
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }

//Delete menu
    export async function deleteMenu(userToken, id){
        const apiPayload = {
            httpMethod:'delete',
            userToken,
            uri:'clientmenus/'+id,
            payLoad:{},
            requestOptions:{}
        }
        return await DoAPICall(apiPayload)
    }




